import styled from '@emotion/styled';
import * as React from 'react';
import { CardTagWidget } from '../../widgets/CardTagWidget';
import { CardWidget } from '../../widgets/CardWidget';
import { ROADMAP_STATUS_LABELS, RoadmapStatus, type RoadmapCard } from '@journeyapps/package-types';

const STATUS_TONE = {
  [RoadmapStatus.UNDER_CONSIDERATION]: 'tool',
  [RoadmapStatus.PLANNED]: 'cloudService',
  [RoadmapStatus.IN_PROGRESS]: 'feature'
} as const;

export const RoadmapCardWidget: React.FC<{ card: RoadmapCard; href?: string; product?: string }> = ({
  card,
  href,
  product
}) => {
  const longDescription = card.description.length > 240 || card.description.split('\n').length > 3;
  return (
    <S.Card
      id={href ? undefined : `roadmap-${card.id}`}
      href={href}
      title={card.title}
      cover={!href && card.coverUrl ? { src: card.coverUrl, fit: 'contain' } : undefined}
      description={card.description}
      descriptionLines={href || longDescription ? 3 : undefined}
      expandable={!href && longDescription}
      metadata={
        <>
          <CardTagWidget $tone={STATUS_TONE[card.status]}>{ROADMAP_STATUS_LABELS[card.status]}</CardTagWidget>
          {product && <S.Product>{product}</S.Product>}
        </>
      }
    />
  );
};

namespace S {
  export const Card = styled(CardWidget)`
    &:target {
      border-color: ${(p) => p.theme.text.special};
    }
  `;
  export const Product = styled.span`
    color: ${(p) => p.theme.text.paragraph};
    font-size: 12px;
  `;
}
